import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTreeConnector = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 12L4.5 12C2.29086 12 0.5 10.2091 0.5 8L0.5 -2.53638e-07",
		stroke: "black",
		strokeOpacity: .35
	})
});
export default SvgTreeConnector;
